import { createRouter, createWebHashHistory } from 'vue-router';
import Index from '../views/Index.vue';

const routes = [
  {
    path: '/index',
    name: 'Index',
    component: Index,
    meta: { title: '日语五十音图' },
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/index',
    meta: { title: '' },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const { title = '' } = to.meta;
  document.title = title;
  next();
});

router.onError((err) => {
  console.log('[route error]', err.message);
});

export default router;
